import styles from './style.module.css';

const Loader = () => {
    return (
        <div className={styles.loader}></div>
    );
};

export default Loader;